import React from 'react';
import { Link } from 'react-router-dom';

// Premium gold-glow wrapped official logo. No fake circle badge, no AI-generated mark.
// Glow combines a CSS drop-shadow filter on the image + a soft radial gradient halo behind.
const LOGO_GLOW_FILTER = 'drop-shadow(0 0 6px rgba(212, 175, 55, 0.55)) drop-shadow(0 0 14px rgba(212, 175, 55, 0.25))';

export const Logo = ({ size = 44, withWordmark = true, className = '', dataTestId = 'site-logo', glow = true }) => {
    return (
        <Link to="/" className={`inline-flex items-center gap-3 group ${className}`} data-testid={dataTestId} aria-label="Legal Alliance Consultancy">
            <span
                className="relative inline-flex items-center justify-center shrink-0"
                style={{ width: size, height: size }}
            >
                {glow && (
                    <span
                        aria-hidden="true"
                        className="absolute inset-0 rounded-full pointer-events-none"
                        style={{
                            background: 'radial-gradient(closest-side, rgba(212,175,55,0.30), rgba(212,175,55,0.06) 55%, transparent 75%)',
                            filter: 'blur(10px)',
                            transform: 'scale(1.45)',
                        }}
                    />
                )}
                <img
                    src="/lac-logo.png"
                    alt="Legal Alliance Consultancy"
                    width={size}
                    height={size}
                    style={{
                        width: size,
                        height: size,
                        filter: glow ? LOGO_GLOW_FILTER : undefined,
                    }}
                    className="relative object-contain select-none"
                    draggable="false"
                />
            </span>
            {withWordmark && (
                <span className="leading-tight hidden sm:block">
                    <span className="block font-display text-[14.5px] tracking-[0.22em] text-la-text">LEGAL ALLIANCE</span>
                    <span className="block font-sans text-[9.5px] tracking-[0.38em] text-la-gold mt-0.5">CONSULTANCY</span>
                </span>
            )}
        </Link>
    );
};

export const LogoMark = ({ size = 120, className = '', glow = true }) => (
    <span className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
        {glow && (
            <span
                aria-hidden="true"
                className="absolute inset-0 rounded-full pointer-events-none"
                style={{
                    background: 'radial-gradient(closest-side, rgba(212,175,55,0.32), rgba(212,175,55,0.06) 55%, transparent 75%)',
                    filter: 'blur(16px)',
                    transform: 'scale(1.5)',
                }}
            />
        )}
        <img
            src="/lac-logo.png"
            alt="Legal Alliance Consultancy seal"
            width={size}
            height={size}
            style={{
                width: size,
                height: size,
                filter: glow ? LOGO_GLOW_FILTER : undefined,
            }}
            className={`relative object-contain select-none ${className}`}
            draggable="false"
        />
    </span>
);

export default Logo;
